<script>
import broker from "../../utils/broker";

import BeritaSidebar from "@/components/sections/berita-sidebar";
import JurusanDetailcontent from "@/components/jurusan-detail-content";
export default {
  props: ["meta"],
  components: {
    BeritaSidebar,
    JurusanDetailcontent,
  },
  data() {
    return {
      jurusanDetail: {},
    };
  },
  mounted() {
    let url = this.$route.query.id;

    broker.fetch.get(`/webschool/content/${url}`).then((res) => {
      this.jurusanDetail = res.data.data;
    });
  },
};
</script>
<template>
  <div class="page-wrapper section-space--inner--60">
    <div class="blog-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="row blog-details">
              <JurusanDetailcontent :data="jurusanDetail" :meta="meta" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
